import React, { useState } from 'react';
import Button from '../UI/Button';
import { startLinkedInLogin } from '../../services/linkedinAuth';

interface LinkedInButtonProps {
  disabled?: boolean;
  onError?: (message: string) => void;
  /** Filled LinkedIn blue — use as the primary SSO action. */
  primary?: boolean;
}

const LinkedInIcon: React.FC = () => (
  <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.47-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45zM22.23 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.46C23.2 24 24 23.23 24 22.27V1.73C24 .77 23.2 0 22.23 0z"
    />
  </svg>
);

const LinkedInButton: React.FC<LinkedInButtonProps> = ({ disabled, onError, primary = false }) => {
  const [isStarting, setIsStarting] = useState(false);

  const handleClick = async () => {
    setIsStarting(true);
    try {
      await startLinkedInLogin();
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Unable to start LinkedIn sign-in.';
      onError?.(message);
      setIsStarting(false);
    }
  };

  return (
    <Button
      type="button"
      variant={primary ? 'primary' : 'outline'}
      fullWidth
      isLoading={isStarting}
      disabled={disabled || isStarting}
      onClick={handleClick}
      className={
        primary
          ? '!bg-[#0A66C2] hover:!bg-[#004182] focus:!ring-[#0A66C2] border border-[#0A66C2]'
          : 'border-[#0A66C2] text-[#0A66C2] hover:bg-[#0A66C2]/5'
      }
    >
      <span className="inline-flex items-center gap-2">
        <LinkedInIcon />
        Continue with LinkedIn
      </span>
    </Button>
  );
};

export default LinkedInButton;
